
import { Component, Mixins } from "vue-property-decorator";
import { FormatReference } from "../../../../domain/format";
import { EditingDocument } from "..";

@Component
export default class ExtraDocumentAccessibleMixin extends Mixins() {
  editingSource: EditingDocument;
  readPropertyOrDefault: <T>(reader: (source: EditingDocument) => T, defaultValue: T) => T;

  get extraFormats(): FormatReference[] {
    return this.readPropertyOrDefault(s => s.extraFormats, []);
  }

  get isExtraPageAddible(): boolean {
    return this.editingSource
      && this.editingSource.isAlreadyInitialized
      && this.extraFormats
      && (0 < this.extraFormats.length);
  }

  get isExtraPageRemovable(): boolean {
    return this.editingSource
      && this.editingSource.isAlreadyInitialized
      && this.editingSource.currentSection
      && (this.editingSource.currentSection.itemSetId !== 0);
  }

  get isExtendedPagePositionSelectable(): boolean {
    return this.editingSource
      && this.editingSource.source.attributes.isExtendedPagePositionSelectable;
  }
}
